const React = require("react");
const { usePrintify } = require("../context/PrintifyContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;

const SellerPrintifyOrders = () => {
  const { api, t } = usePrintify();
  const resource = useResource(() => api.getOrders({ page: 1, limit: 100 }), [api]);
  const [busy, setBusy] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const orders = resource.data?.orders || [];

  const run = async (order, action, success) => {
    setBusy(order._id); setMessage(""); setError("");
    try { await action(); setMessage(success); await resource.reload(); }
    catch (requestError) { setError(requestError.message); }
    finally { setBusy(""); }
  };

  const createOrder = (order) => {
    const orderId = order.orderId?._id || order.orderId;
    if (!orderId || !window.confirm(t("h_printify_confirm_send_order", "Send this paid order to Printify? Production charges may apply."))) return;
    run(order, () => api.createSupplierOrder(orderId, order.sellerId?._id || order.sellerId), t("h_printify_order_sent", "Order sent to Printify."));
  };

  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_printify_orders_title", "Printify orders"),
      description: t("h_printify_orders_desc", "Supplier status, tracking and fulfillment errors."),
      action: h(Button, { variant: "secondary", disabled: resource.loading || Boolean(busy), onClick: resource.reload }, t("h_printify_refresh", "Refresh")),
    }),
    message ? h("div", { className: "pyds-success", role: "status" }, message) : null,
    error ? h("div", { className: "pyds-alert", role: "alert" }, error) : null,
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !orders.length, reload: resource.reload, t },
      h("div", { className: "pyds-table-wrap" }, h("table", { className: "pyds-table" },
        h("thead", null, h("tr", null,
          h("th", null, t("h_printify_order", "Order")),
          h("th", null, t("h_printify_status", "Status")),
          h("th", null, t("h_printify_tracking", "Tracking")),
          h("th", null, t("h_printify_error", "Error")),
          h("th", null, t("h_printify_actions", "Actions"))
        )),
        h("tbody", null, ...orders.map((order) => {
          const orderId = order.orderId?._id || order.orderId;
          return h("tr", { key: order._id },
            h("td", null, order.dropshippingOrderId || String(orderId || "").slice(-10) || "—"),
            h("td", null, h(StatusBadge, { status: order.supplierStatus || order.status, t })),
            h("td", null, order.trackingUrl ? h("a", { href: order.trackingUrl, target: "_blank", rel: "noopener noreferrer" }, order.trackingNumber || t("h_printify_track", "Track")) : "—"),
            h("td", null, order.errorSafeMessage || "—"),
            h("td", null, h("div", { className: "pyds-row" },
              !order.supplierOrderId ? h(Button, { disabled: busy === order._id || !orderId, onClick: () => createOrder(order) }, order.errorSafeMessage ? t("h_printify_retry_order", "Retry order") : t("h_printify_send_order", "Send order")) : null,
              order.supplierOrderId ? h(Button, { variant: "secondary", disabled: busy === order._id, onClick: () => run(order, () => api.syncOrder(order._id), t("h_printify_order_synced", "Order status updated.")) }, t("h_printify_sync", "Sync")) : null
            ))
          );
        }))
      ))
    )
  );
};

module.exports = { SellerPrintifyOrders };
